import { Component, OnInit, Inject, Input          } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA      } from '@angular/material/dialog';
import { DialogsReturnCode                  } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                     } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                     } from 'src/app/managers/loading/loading.manager';
import { SessionManager                     } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'generic-dialog',
  templateUrl: './generic.dialog.html',
  styleUrls: ['./generic.dialog.scss'],
})

export class GenericDialog implements OnInit 
{
  title       : string = "dialog.generic.title"
  body        : string = "dialog.generic.body"
  confirm_text: string = "dialog.generic.confirm"
  cancel_text : string = "dialog.generic.cancel"

  confirm_code     : boolean = false
  confirm_code_text: string  = "dialog.generic.confirm_code"
  code             : string
  input_code       : string

  hideCancel: boolean = false

  constructor
  (
    private dialogRef : MatDialogRef<GenericDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any      ,
    
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  ngOnInit(): void
  {
    if(this.data)
    {
      if(this.data.title            ) this.title             = this.data.title 
      if(this.data.body             ) this.body              = this.data.body
      if(this.data.confirm_text     ) this.confirm_text      = this.data.confirm_text
      if(this.data.cancel_text      ) this.cancel_text       = this.data.cancel_text
      if(this.data.confirm_code     ) this.confirm_code      = this.data.confirm_code
      if(this.data.confirm_code_text) this.confirm_code_text = this.data.confirm_code_text
      if(this.data.input_code       ) this.input_code        = this.data.input_code
      if(this.data.hideCancel       ) this.hideCancel        = this.data.hideCancel 
      console.log(this.input_code)
    }
  }

  //---------------------------------------------------------------------------------------------------
  
  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  continue()
  {
    if( this.input_code && this.code && this.input_code === this.code )
    {
      console.log("sono qua");
      
      this.dialogRef.close
      ( 
        {
          code: DialogsReturnCode.PRENOTATION_DELETE
        }
      )
    }
    else
    {
      this.dialogRef.close
      ( 
        {
          code: DialogsReturnCode.OPERATION_ACCEPTED
        }
      )
    }
  }
}
